(() => {
  const root = document.documentElement;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setScrolled = () => {
    root.classList.toggle('is-gv2-scrolled', window.scrollY > 12);
  };

  setScrolled();
  window.addEventListener('scroll', setScrolled, { passive: true });

  const initHeroScrollMotion = () => {
    const hero = document.querySelector('.home-editorial-hero');
    if (!hero || prefersReducedMotion.matches) return;

    let ticking = false;

    const setHeroMotion = () => {
      const heroHeight = hero.offsetHeight || 1;
      const travel = Math.min(heroHeight * 0.72, 560);
      const progress = Math.max(0, Math.min(1, window.scrollY / travel));

      const easedProgress = 1 - Math.pow(1 - progress, 3);

      hero.style.setProperty('--gd-hero-scroll-progress', easedProgress.toFixed(3));
      hero.style.setProperty('--gd-hero-height-shrink', '0px');
      hero.style.setProperty('--gd-hero-media-scale', (1.025 + easedProgress * 0.105).toFixed(3));
      hero.style.setProperty('--gd-hero-media-y', `${Math.round(easedProgress * 20)}px`);
      hero.style.setProperty('--gd-hero-content-y', `${Math.round(easedProgress * -16)}px`);
      ticking = false;
    };

    const requestHeroMotion = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(setHeroMotion);
    };

    setHeroMotion();
    window.addEventListener('scroll', requestHeroMotion, { passive: true });
    window.addEventListener('resize', requestHeroMotion, { passive: true });
  };

  initHeroScrollMotion();

  const initHowAtmosphere = () => {
    const section = document.querySelector('[data-how-atmosphere].home-how-dark--motion-interactive');
    if (!section || prefersReducedMotion.matches) return;

    let ticking = false;
    let pointerX = 0.5;
    let pointerY = 0.5;

    const renderAtmosphere = () => {
      const rect = section.getBoundingClientRect();
      const scrollBlend = Math.max(-1, Math.min(1, (rect.top + rect.height * 0.5 - window.innerHeight * 0.5) / Math.max(rect.height, 1)));
      const driftX = (pointerX - 0.5) * 10;
      const driftY = ((pointerY - 0.5) * 8) - scrollBlend * 5;

      section.style.setProperty('--gd-how-react-x', `${Math.round(pointerX * 100)}%`);
      section.style.setProperty('--gd-how-react-y', `${Math.round(pointerY * 100)}%`);
      section.style.setProperty('--gd-how-drift-x', `${driftX.toFixed(2)}px`);
      section.style.setProperty('--gd-how-drift-y', `${driftY.toFixed(2)}px`);
      ticking = false;
    };

    const requestAtmosphere = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(renderAtmosphere);
    };

    section.addEventListener('pointermove', (event) => {
      const rect = section.getBoundingClientRect();
      pointerX = Math.max(0, Math.min(1, (event.clientX - rect.left) / Math.max(rect.width, 1)));
      pointerY = Math.max(0, Math.min(1, (event.clientY - rect.top) / Math.max(rect.height, 1)));
      requestAtmosphere();
    }, { passive: true });

    section.addEventListener('pointerleave', () => {
      pointerX = 0.5;
      pointerY = 0.5;
      requestAtmosphere();
    }, { passive: true });

    window.addEventListener('scroll', requestAtmosphere, { passive: true });
    window.addEventListener('resize', requestAtmosphere, { passive: true });
    renderAtmosphere();
  };

  initHowAtmosphere();

  const announcement = document.querySelector('[data-goodest-announcement]');
  const announcementDismiss = document.querySelector('[data-goodest-announcement-dismiss]');
  const announcementCookie = 'goodest_announcement_dismissed=true';

  if (announcement && document.cookie.includes(announcementCookie)) {
    announcement.hidden = true;
  }

  if (announcement && announcementDismiss) {
    announcementDismiss.addEventListener('click', () => {
      announcement.hidden = true;
      document.cookie = `${announcementCookie}; path=/`;
    });
  }

  const revealItems = document.querySelectorAll('.gv2-reveal');
  if (!revealItems.length) return;

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.18 }
  );

  revealItems.forEach((item) => observer.observe(item));
})();
